let accessToken: string | null = null
let accessTokenExpiresAt = 0

export function setGoogleDriveAccessToken(token: string, expiresInSeconds: number) {
  accessToken = token
  accessTokenExpiresAt = Date.now() + Math.max(0, expiresInSeconds - 60) * 1000
}

export function getGoogleDriveAccessToken() {
  if (!accessToken || Date.now() >= accessTokenExpiresAt) return null
  return accessToken
}

export function clearGoogleDriveAccessToken() {
  accessToken = null
  accessTokenExpiresAt = 0
}
